// style sheet used
import "./App.css";

// Components
import LandingPage from "./LandingPage";
import Shop from "./Shop";

// Below Ive used created Homepage component to render the LandingPage and Shop component.
const Homepage = () => {
  return (
    <div className="homepage">
      <LandingPage />
      <Shop />
    </div>
  );
};

export default Homepage;
